// @flow
import React, { useContext } from 'react';
import { ConnectTasksAlertContainer } from '@src/triggers/ConnectTasksAlertContainer';
import { KafkaClustersAlertContainer } from '@src/triggers/KafkaClustersAlertContainer';

import { EstimateContext } from '../../../contexts/EstimateContext';
import { ESTIMATE_COMMIT_SUMMARY } from '../../../constants';
import { IfElse } from '../../presentational/IfElse';
import { PaddedAndRaisedSegment } from '../../presentational/PaddedAndRaisedSegment';
import { Spacer } from '../../presentational/spacing/Spacer';
import { StyledDiv } from '../../../common-utils/styledComponents';
import { TCVApprovalRequiredContainer } from '../../../triggers/TCVApprovalRequiredContainer';

import { CommitSummaryTable } from './CommitSummaryTable';
import { DspCommitSummaryLayout } from './DspCommitSummaryLayout';

// DSP estimates split the commit summary into three cards: Commit 1 (non-DSP),
// Commit 2 (DSP), and the Total Overall Commit. Non-DSP estimates only ever send
// commit_summary, so partial DSP data (only one of the two extra cards) means the
// back end and front end have gone out of sync and should fail loudly.
export const CommitSummaryContainer = ({ disabled }) => {
  const estimateData = useContext(EstimateContext);
  const {
    commit_summary: commitSummary,
    commit_summary_for_dsp: commitSummaryDsp,
    total_overall_commits: totalOverallCommits,
  } = estimateData;

  const isDspEstimate = Boolean(commitSummaryDsp) || Boolean(totalOverallCommits);
  const hasAllDspCommitSummaryCards =
    Boolean(commitSummary) && Boolean(commitSummaryDsp) && Boolean(totalOverallCommits);

  if (isDspEstimate && !hasAllDspCommitSummaryCards) {
    throw new Error(
      'Incomplete DSP commit summary: expected commit_summary, commit_summary_for_dsp, and total_overall_commits to all be present.'
    );
  }

  return (
    <PaddedAndRaisedSegment disabled={disabled}>
      <StyledDiv width={isDspEstimate ? '100%' : '730px'}>
        {/* todo::DSP Check with Nithin if this is still required and how it should work */}
        <TCVApprovalRequiredContainer />
        <ConnectTasksAlertContainer />
        <KafkaClustersAlertContainer />
        <Spacer y={1} />
        <IfElse
          elseContent={
            <CommitSummaryTable inputDataSource={commitSummary} label={ESTIMATE_COMMIT_SUMMARY} />
          }
          ifContent={
            <DspCommitSummaryLayout
              commitSummary={commitSummary}
              commitSummaryDsp={commitSummaryDsp}
              totalOverallCommits={totalOverallCommits}
            />
          }
          test={isDspEstimate}
        />
      </StyledDiv>
    </PaddedAndRaisedSegment>
  );
};
